// extracted by mini-css-extract-plugin
module.exports = {"Right":"Notice_Right__1GvBM","Button":"Notice_Button__2KpXU"};